import React, { FC, useState } from 'react';

import { PageTitle } from '../page-title/page-title.component';
import { ReactComponent as SignOutButton } from '../../assets/signout.svg';
import { ReactComponent as BackArrow } from '../../assets/trak-back-arrow.svg';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/UserContext';
import { ConfirmationModal } from '../confirmation-modal/confirmation-modal.component';

type Props = {
  title: string;
  showBack?: boolean;
};

export const PageHeader: FC<Props> = ({ title, showBack }) => {
  const navigate = useNavigate();
  const { logout, isLoggedIn } = useAuth();
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <>
      <div className={'py-2 md:py-5 lg:py-8 xl:py-10 flex flex-row items-center'}>
        <div className="w-1/4 flex justify-center items-center">
          <div className="p-5 cursor-pointer" onMouseDown={() => navigate(-1)}>
            {showBack && <BackArrow width={30} height={30} />}
          </div>
        </div>

        <div className="w-1/2">
          <PageTitle>{title}</PageTitle>
        </div>

        <div className="w-1/4 flex justify-center items-center">
          <div className="p-5 cursor-pointer" onMouseDown={() => setModalOpen(true)}>
            {isLoggedIn && <SignOutButton width={30} height={30} />}
          </div>
        </div>

        {
          modalOpen
          &&
          <div className='absolute top-0 left-0 bottom-0 right-0'>
            <ConfirmationModal confirm={logout} cancel={() => setModalOpen(false)}>Are you sure you want to sign out?</ConfirmationModal>
          </div>
        }
      </div>

    </>

  );
};
